

























































































































































































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import Placeholder from '@/components/Placeholder.vue';
import {DeviceVersionInterface, Interface, InterfaceField, Unit} from '@/types';
import InterfaceService from '@/services/interface.service';
import Dialog from '@/components/Dialog.vue';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';
import CancelButton from '@/components/CancelButton.vue';
import GenericButton from '@/components/GenericButton.vue';

@Component({
  components: {
    GenericButton,
    CancelButton,
    Dialog,
    Placeholder,
  },
})
export default class AdminInterfaces extends Vue {
  private interfaces: Interface[] = [];
  private loading: boolean = false;
  private fieldTypes: string[] = ['int', 'float', 'boolean', 'string'];
  private editedIndex: number = -1;
  private editedInterfaceIndex: number = -1;
  private snackbar: boolean = false;
  private selectedInterface: number | null = null;
  private showDeleteModal: boolean = false;
  private preventConfirm: boolean = false;
  private mappings: DeviceVersionInterface[] = [];
  private editing: boolean = false;
  private headers: any[] = [
    {
      text: 'Field name',
      value: 'field_name',
      sortable: true,
    },
    {
      text: 'Type',
      value: 'type',
      sortable: true,
      width: '150px',
    },
    {
      text: 'Unit',
      value: 'unit',
      sortable: false,
      width: '150px',
    },
    {
      text: 'Description',
      value: 'description',
      sortable: false,
    },
    { text: 'Actions', value: 'actions', sortable: false , width: '100px'},
  ];
  private editedInterface: any = {
    name: '',
    type: '',
  };
  private editedField: any = {
    interface_id: null,
    field_name: '',
    type: '',
    description: '',
    unit: null,
    unit_id: null,
  };
  private defaultField: any = {
    interface_id: null,
    field_name: '',
    type: '',
    description: '',
    unit: null,
  };
  private units: Unit[] = [];
  private interfaceTypes: string[] = ['measurement', 'count', 'event', 'report'];

  private async mounted() {
    this.populateUnits();
    if (!this.interfaces.length) {
      await this.populateInterfaces();
    }
  }

  private get sortedInterfaces() {
    const compare = (a: Interface, b: Interface) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    };

    return this.interfaces.sort(compare);
  }

  private addInterface() {
    if (this.$refs.interfacesListWrapper) {
      (this.$refs.interfacesListWrapper as Element).scrollTop = 0;
    }

    const addObj: any = Object.assign({}, {name: '', type: null, fields: []});
    addObj.id = 'new';
    this.interfaces.unshift(addObj);

    this.editInterface(addObj);
  }

  private editInterface(iface: Interface) {
    this.selectedInterface = iface.id || null;
    this.editedInterfaceIndex = this.interfaces.indexOf(iface);
    this.editedInterface = Object.assign({}, iface);
  }

  private closeInterface(iface: Interface) {
    if (!iface.name.length) {
      this.interfaces = this.interfaces.filter((i) => i.name);
      // this.deleteInterface(iface);
    }
    this.editedInterface = Object.assign({}, {name: '', type: null, fields: []});
    this.editedInterfaceIndex = -1;
  }

  private async saveInterface(iface: Interface) {
    if (iface.id as any !== 'new') {
      iface.name = this.editedInterface.name;
      iface.type = this.editedInterface.type;
      await this.updateInterface(iface);
      this.closeInterface(iface);
    } else {
      delete this.editedInterface.id;
      iface = Object.assign({}, this.editedInterface);
      const { id } = await InterfaceService.createInterface(this.editedInterface);

      iface.id = id;
      this.selectedInterface = id;
      this.interfaces.push(iface);
      this.closeInterface(iface);
    }
    this.interfaces = this.interfaces.filter((f) => f.name);

  }

  private async checkForMappings(iface: Interface) {
    const mappings = await AdminDeviceTypeService.getAllMappingsForInterfaceId(Number(iface.id));
    Vue.set(this, 'mappings', mappings);
    if (!this.mappings.length) {
      await this.deleteInterface(iface);
    } else {
      this.showDeleteModal = true;
      this.preventConfirm = true;
    }
  }

  private async deleteInterface(iface: Interface) {
    await InterfaceService.deleteInterface(Number(iface.id));
    const index = this.interfaces.indexOf(iface);
    this.interfaces.splice(index, 1);
  }

  private async populateInterfaces() {
    const interfaces = await InterfaceService.getInterfaces();
    Vue.set(this, 'interfaces', interfaces);
  }

  private async populateUnits() {
    const units = await InterfaceService.getUnits();
    Vue.set(this, 'units', units);
  }

  private async updateInterface(iface: Interface) {
    this.loading = true;
    try {
      await InterfaceService.updateInterface(Number(iface.id), iface);
    } finally {
      this.loading = false;
    }
  }

  private async editField(item: InterfaceField) {
    item.interface_id = this.selected.id;
    this.editedIndex = this.selected.fields.indexOf(item);
    this.editedField = Object.assign({}, item);
  }

  private async deleteField(item: InterfaceField) {
    const index = this.selected.fields.indexOf(item);
    this.selected.fields.splice(index, 1);

    await InterfaceService.deleteInterfaceField(Number(this.selected.id), Number(item.id));
  }

  private closeField() {
    this.selected.fields = this.selected.fields.filter((f) => f.field_name && f.type);
    this.editedField = Object.assign({}, this.defaultField);
    this.editedIndex = -1;
  }

  private addNewField() {
    if (this.$refs.fieldsListWrapper) {
      (this.$refs.fieldsListWrapper as Element).scrollTop = 0;
    }

    const addObj = Object.assign({}, this.defaultField);
    addObj.id = 'new';
    this.selected.fields.unshift(addObj);

    this.editField(addObj);
  }

  private async saveField(item: InterfaceField) {
    if (this.editedField.id !== 'new') {
      item.field_name = this.editedField.field_name;
      item.type = this.editedField.type;
      item.description = this.editedField.description;
      item.unit_id = this.editedField.unit_id;
      item.unit = this.editedField.unit;
      await InterfaceService.updateInterfaceField(Number(this.selected.id), Number(this.editedField.id), this.editedField);
      this.closeField();
    } else {
      delete this.editedField.id;
      const { id } = await InterfaceService.createInterfaceField(Number(this.selected.id), this.editedField);
      this.editedField.id = id;
      this.selected.fields.push(this.editedField);
      this.closeField();
    }

    this.selected.fields = this.selected.fields.filter((f) => f.field_name && f.type);
  }

  @Watch('editedField.unit_id')
  private handleEditedFieldUnitIdChange(value: number | null) {
    this.editedField.unit = value ? this.units.find((u: Unit) => u.id === value) || null : null;
  }

  private get selected() {
    const iface = this.interfaces.find((i: Interface) => i.id === this.selectedInterface);
    if (iface) {
      return iface;
    } else {
      return this.interfaces[0];
    }
  }

  private get fields() {
    const iface = this.interfaces.find((i) => i.id === this.selectedInterface);
    if (iface) {
      return iface.fields;
    } else {
      return [];
    }
  }

  private get unitTypes() {
    return [
      { text: 'None', value: null },
      ...this.units.map((u: Unit) => ({
        value: u.id,
        text: `${u.description} [${u.symbol}]`,
      })),
    ];
  }
}
